var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetElasticSuggestions, Vendd.ElasticSearch, function (envelope) {

        var options = {
            url: document.location.protocol.toLowerCase() + "//" + document.location.host.toLowerCase() + "/api/search/suggest",
            data: {
                queryTerm: envelope.message.data.queryTerm,
                size: envelope.message.data.size,
                since: envelope.message.data.since,
                case: envelope.message.data.case,
                fuzziness: envelope.message.data.fuzziness,
                source: envelope.message.data.source,
                path: envelope.message.data.path ? envelope.message.data.path : "/",
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            var request = { request: options.data };
            _.extend(response, request);

            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetElasticSuggestionsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetElasticSuggestionsFailed(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetFiltersElasticResults, Vendd.ElasticSearch, function (envelope) {

        var options = {
            url: document.getElementById("base_engine").href + "esqueryfiltervalues",
            data: {
                type: "products",
                query: envelope.message.data.searchTerm,
                path: envelope.message.data.path ? envelope.message.data.path : "/",
                filters: envelope.message.data.filters,
                baseuri: envelope.message.data.baseuri
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetFiltersElasticResultsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetFiltersElasticResultsFailed(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetCategoryElasticResults, Vendd.ElasticSearch, function (envelope) {

		var options = {
            url: document.getElementById("base_engine").href + "esqueryindex" + "?hidefromsearch=1",
			data: {
				type: "categories",
				query: envelope.message.data.searchTerm,
				pagefrom: envelope.message.data.pageFrom,
                pagesize: envelope.message.data.pageSize,
                path: envelope.message.data.path ? envelope.message.data.path : "/",
			},
            onSuccess: onSuccess,
            onFailure: onFailure
		};

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetCategoryElasticResultsSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetCategoryElasticResultsFailed(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetProductElasticResults, Vendd.ElasticSearch, function (envelope) {

        var options = {
            url: document.getElementById("base_engine").href + "esqueryindex" + (envelope.message.data.query ? envelope.message.data.query : "") + "?hidefromsearch=1",
			data: {
				type: "products",
				query: envelope.message.data.searchTerm,
				pagefrom: envelope.message.data.pageFrom, 
                pagesize: envelope.message.data.pageSize,
                path: envelope.message.data.path ? envelope.message.data.path : "/",
                es_fields: envelope.message.data.fields ? envelope.message.data.fields : "",
                es_geo_window: envelope.message.data.geo_window ? envelope.message.data.geo_window : ""
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

        //extend data options with filters
        if (envelope.message.data.filters)  _.extend(options.data, envelope.message.data.filters);

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetProductElasticResultsSuccess(response, envelope.sender));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetProductElasticResultsFailed(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetArticleElasticResults, Vendd.ElasticSearch, function (envelope) {

        var options = {
            url: document.getElementById("base_engine").href + "esqueryindex" + "?hidefromsearch=1",
            data: {
                type: "articles",
                query: envelope.message.data.searchTerm,
                pagefrom: envelope.message.data.pageFrom,
                pagesize: envelope.message.data.pageSize,
                path: envelope.message.data.path ? envelope.message.data.path : "/",
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetArticleElasticResultsSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetArticleElasticResultsFailed(response));
        }

        Vendd.Service.call(options);
    });
    return Vendd;

})(Vendd || {});